var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hot-panel-multi"},[_c('section-title',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"hot-panel-multi-content",domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm.clickHandle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }